const policyStatusMaster = {
  Application: 'Quick Quote', // when we move from Quote to Application
  QuoteIndication: 'Quote Indication',
  Rated: 'Rated',
  PendingCancellationEndorsementInitiated: 'Pending Cancellation - Endorsement Initiated',
  SubmissionUnderReview: 'Submission Under Review',
  Submission: 'Submission', // when we move from Quote to Application
  SubmissionDeclined: 'Submission Declined',
  SubmissionApproved: 'Submission Approved',
  SubmissionDeclinedByUW: 'Submission Declined by UW',
  ReferralAwaitingUWReview: 'Referral - Awaiting UW Review', // When UW rules are hit
  QuoteExpired: 'Quote Expired', // Calcualated in batch Job based on no.OfDays Quote is old
  QuoteOffered: 'Quote Offered', // When UW approve and offer Quote submitted to him by agent
  UWQuoteDeclined: 'UW - Quote Declined', // When underwriter declines Quote
  BindRequestDeclined: 'Bind Request - Declined',
  BindSignaturePending: 'Bound - Awaiting Documentation / Signature', //When Bind Signature is pending by Insured and Agent
  // BindSignaturePending: 'Bind Signature Pending', //When Bind Signature is pending by Insured and Agent
  BindRequestAwaitingUWApproval: 'Bind Request - Awaiting UW Approval', // Agent submitted the application now, waiting for UW approval
  BoundRequestAwaitingUWApproval: 'Bound - Final UW Review',
  // BindSignaturePending: 'Bind Signature Pending', //When Bind Signature is pending by Insured and Agent
  RetailerQuoteDeclined: 'Submission Declined by UW', // When Agent rejects the policy
  PolicyInForce: 'Policy In Force', // UW Approves the policy
  BindRequestDeclinedbyUW: 'Bind Request Declined by UW', // UW declined bind request by Agent
  BindRequestonHold: 'Bind Request on Hold', // UW put policy in application on Hold coz some documents or something
  BindRequestUnderReview: 'Bind Request - Under Review', // UW put policy in application on Hold coz some documents or something
  PolicyInForceEndorsed: 'Policy In Force-Endorsed', // UW approves endorsed policy submitted
  EndorsementInitiated: 'Endorsement Initiated',
  EndorsementReferred: 'Endorsement Referred',
  EndorsementRequestAwaitingUWApproval: 'Endorsement - Awaiting UW Approval',
  EndorsementRequestOnHold: 'Policy In Force - Endorsement Request On Hold',
  EndorsementApprovedByUW: 'Endorsement - Approved by UW',
  EndorsementApprovedPendingPayment: 'Endorsement Approved - Pending Payment',
  EndorsementDeclined: 'Endorsement - Declined by UW',
  CancellationInitiated: 'Cancellation Initiated',
  CancellationOnHold: 'Cancellation on Hold',
  PolicyInForceCancellationRequestPendingApproval: 'Cancellation Request Pending Approval', // Agents cancels a policy but Waiting for UW approval
  PolicyCancelledReinstatementRequestPendingUWApproval: 'Reinstatement Request - Pending UW Review', // Agents request to reinstate a cancelled policy but Waiting for UW approval
  // PolicyInForceCancellationSignaturePending: 'Cancellation Signature Pending',
  PolicyCancelled: 'Policy Cancelled', // Policy is cancelled by UW
  ReInstatementInitiated: 'Reinstate Initiated',
  PolicyInForceReInstated: 'Policy ReInstated',
  EndorsementRequestDecline: 'Endorsement Declined by UW',
  AwaitingPaymentApproval: process.env.NEXT_PUBLIC_LINE_OF_BUSINESS === 'HO3' ? 'Awaiting Payment Approval' : null,
  RewriteInProgress: 'Rewrite - InProgress',
  Rewritten: 'Rewritten',

  // CA
  SubmissionClosed: 'Submission Closed',
  LOBNotOfferedByAgent: 'LOB Not Offered By Agent',
  LOBNotOfferedByUW: 'LOB Not Offered By UW',
  FileClosed: 'File Closed',
  PolicyInForceBind: 'Policy In Force - Bind', // UW Approves the policy,
  PendingCancellation: 'Pending Cancellation',
  RescindRequestPendingApproval: 'Rescind Request Pending Approval',
  InsuredPaymentPending: 'Insured Payment Pending',
  InsuredSignaturePending: 'Insured Signature Pending',
  AgentSignaturePending: 'Agent Signature Pending',
};

const accountHubPolicyStatusMaster = {
  QuoteIndication: 'Quote Indication',
  Rated: 'Rated',
  Submission: 'Submission', // when we move from Quote to Application
  SubmissionDeclined: 'Submission Declined',
  ReferralAwaitingUWReview: 'Referral - Awaiting UW Review', // When UW rules are hit
  SubmissionApproved: 'Submission Approved',
  SubmissionDeclinedByUW: 'Submission Declined by UW',
  QuoteExpired: 'Quote Expired', // Calcualated in batch Job based on no.OfDays Quote is old
  QuoteOffered: 'Quote Offered', // When UW approve and offer Quote submitted to him by agent
  InsuredPaymentPending: 'Insured Payment Pending',
  InsuredSignaturePending: 'Insured Signature Pending',
  AgentSignaturePending: 'Agent Signature Pending',
  PolicyInForce: 'Policy In Force',
  CancellationInitiated: 'Cancellation Initiated',
  PolicyInForceCancellationRequestPendingApproval: 'Cancellation Request Pending Approval',
  PolicyCancelled: 'Policy Cancelled',
  ReInstatementInitiated: 'Reinstate Initiated',
  PolicyCancelledReinstatementRequestPendingUWApproval: 'Reinstatement Request - Pending UW Review',
  PendingCancellation: 'Pending Cancellation',

  //Endorsement
  EndorsementInitiated: 'Endorsement Initiated',
  EndorsementRequestAwaitingUWApproval: 'Endorsement - Awaiting UW Approval',
  EndorsementApprovedByUW: 'Endorsement - Approved by UW',
  EndorsementApprovedPendingPayment: 'Endorsement Approved - Pending Payment',
  EndorsementDeclined: 'Endorsement - Declined by UW',
};

const accountHubNonPremiumPolicyStatus = [
  accountHubPolicyStatusMaster.QuoteIndication,
  accountHubPolicyStatusMaster.Rated,
  accountHubPolicyStatusMaster.Submission,
  accountHubPolicyStatusMaster.SubmissionDeclined,
  accountHubPolicyStatusMaster.ReferralAwaitingUWReview,
  accountHubPolicyStatusMaster.SubmissionApproved,
  accountHubPolicyStatusMaster.SubmissionDeclinedByUW,
  accountHubPolicyStatusMaster.QuoteExpired,
  accountHubPolicyStatusMaster.PolicyCancelled,
];

const transactionTypeMaster = {
  QUOTE: 'Quote', // for all the Transaction > Type before bind
  QuoteOffered: 'QuoteOffered',
  APPLICATION: 'Application',
  POLICY: 'Policy', // when policy is bound
  ENDORSEMENT: 'Endorsement', // for all endorsement transactions
  CANCELLATION: 'Cancellation', // for all cancellation
  REINSTATE: 'Reinstate', // for all reinstatement
  RENEWAL: 'Renewal', // for all renewal
  NEWQUOTE: 'Quote',
};

const transactionStatusMaster = {
  INPROGRESS: 'In-Progress',
  RATED: 'Rated',
  READYTOCOMMIT: 'Ready-To-Commit',
  COMMITTED: 'Committed',
};

const premiumTypeMaster = {
  FLAT: 'Flat',
  PRO_RATE: 'ProRate',
  SHORT_RATE: 'ShortRate',
};

const statusMaster = {
  Active: 'Active',
  InActive: 'InActive',
};

// IH PERSONAL AUTO

const HyunModelArray = ['ACCENT', 'ELANTRA', 'KONA', 'SANTA', 'TUCSON', 'SONATA'];
const KiaModelArray = ['FORTE', 'OPTIMA', 'RIO', 'SEDONA', 'SOUL', 'SPORTAGE'];
const arrayMake = ['KIA', 'HYUN'];
const renewalsPolicyStatusMaster = {
  //RenewalOfferGenerated: 'Renewal Offer Generated',
  RenewalOfferGenerated: 'Renewal Offer Generated',
  //IntentToRenewSent: 'Intent to Renew Sent',
  RenewalDeclined: 'Renewal Declined',
  RenewalOffered: 'Renewal Offered',
  //RenewalSubmission: 'Renewal Submission',
  RenewalSubmission: 'Renewal Submission',
  RenewalOfferRerated: 'Renewal Offer Rerated',
  //RenewalOfferApproved: 'Renewal Offer Approved',
  //RenewalOfferRejected: 'Renewal Offer Rejected',
  //RenewalAwaitingUWReview: 'Renewal Awaiting UW Review',
  RenewalSignaturePending: 'Renewal Signature Pending',
  //PolicyRenewed: 'Policy Renewed',
  Renewed: 'Renewed',
  RenewalCancellationInitiated: 'Renewal - Cancellation Initiated',
  RenewalCancelUWApproval: 'Renewal - Cancellation Request Pending Approval',
  RenewalCancelled: 'Renewal - Cancelled',
  RenewalEndorsementInitiated: 'Renewal - Endorsement Initiated',
  RenewalEndorsementRequestApproved: 'Renewal - Endorsement Request Approved',
  RenewalEndorsementReferred: 'Renewal - Endorsement Referred',
  RenewalEndorsementRequestAwaitingUWApproval: 'Renewal - Endorsement Request Awaiting UW Approval',
  RenewalEndorsementRequestOnHold: 'Renewal - Endorsement Request On Hold',
  RenewalEndorsed: 'Renewal - Endorsed',
  //RenewalSubmissionClosed: 'Renewal Submission Closed',
  //PolicyRenewed: 'Policy Renewed',
  RenewalSubmissionClosed: 'Renewal Submission Closed',
  RenewalBindSignaturePending: 'Renewal – Bind Signature Pending',
  RenewalBindRequestAwaitingUWApproval: 'Renewal Bind Request – Awaiting UW Approval',
  RenewalReferralAwaitingUWReview: 'Referral - Renewal Awaiting UW Review',
  RenewalSubmissionDeclined: 'Renewal - Submission Declined',
  RenewalExpired: 'Renewal Expired',
  RenewalReInstatementInitiated: 'Renewal - Reinstatement Initiated',
  RenewalCancelledReinstatementRequestPendingUWApproval: 'Renewal - Reinstatement Request Pending UW Approval',
  //RenewalCancelledReinstatementSignaturePending: 'Renewal - Reinstatement Signature Pending'
};

export {
  premiumTypeMaster as PremiumTypeMaster,
  statusMaster as StatusMaster,
  policyStatusMaster as PolicyStatusMaster,
  transactionTypeMaster as TransactionTypeMaster,
  transactionStatusMaster as TransactionStatusMaster,
  HyunModelArray,
  KiaModelArray,
  arrayMake,
  renewalsPolicyStatusMaster as RenewalsPolicyStatusMaster,
  accountHubPolicyStatusMaster as AccountHubPolicyStatusMaster,
  accountHubNonPremiumPolicyStatus as AccountHubNonPremiumPolicyStatus,
};
